<template>
  <v-app id="mail" class="mail">
    <v-toolbar class="app--toolbar"   color="primary" fixed dark>
      <v-toolbar-title class="ml-0 pl-3" to="/" >
      <span class="hidden-sm-and-down" > جمعية تواصل الأجيال</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <div>
        <v-btn icon to="/database/DB/fr" >
          <img src="static/icon/aa.png" width="24px">
        </v-btn>
        <v-btn icon to="/database/DB/Ar" >
          <img src="static/icon/tn.png" width="24px">
        </v-btn>

      </div>
    </v-toolbar>
    <div id="social">
      <v-container grid-list-xl fluid style="padding-top: 5%">
        <v-layout row wrap>
          <v-flex lg6 sm6 xs6>
            <img src="static/FAO.png"  width="60%">
          </v-flex>
          <v-flex lg6 sm6 xs6>
            <img src="static/logo.png" align="right"  width="50%">
          </v-flex>
          <!-- mini statistic start -->
          <v-flex lg3 sm6 xs12>
            <mini-statistic
                    icon="fa fa-facebook"
                    :title="countall"
                    sub-title="المجموع"
                    caption="إمرأة"
                    color="green"
            >
            </mini-statistic>
          </v-flex>
          <v-flex lg3 sm6 xs12>

            <v-menu offset-y style="width: 100%">
              <mini-statistic
                      icon="fa fa-facebook"
                      :title="countsfax"
                      sub-title="صفاقس"
                      caption="إمرأة"
                      style="width: 100%"
                      slot="activator"
                      color="indigo"
              >
              </mini-statistic>
              <v-list>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">S2 : </a>{{s3}} <a style="color: #9c27b0">إمرأة</a></v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">S4 : </a>{{s4}} <a style="color: #9c27b0">إمرأة</a></v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">S5 : </a>{{s5}} <a style="color: #9c27b0">إمرأة</a></v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">S6 : </a>{{s6}} <a style="color: #9c27b0">إمرأة</a></v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>

          </v-flex>
          <v-flex lg3 sm6 xs12>

            <v-menu offset-y style="width: 100%">
              <mini-statistic
                      icon="fa fa-google"
                      :title="countgabes"
                      sub-title="قابس"
                      caption="إمرأة"
                      style="width: 100%"
                      slot="activator"
                      color="red"
              >
              </mini-statistic>
              <v-list>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">G1 : </a>{{g1}} <a style="color: #9c27b0">إمرأة</a></v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">G2 : </a>{{g2}} <a style="color: #9c27b0">إمرأة</a></v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-title><a style="color: #9c27b0">G3 : </a>{{g3}} <a style="color: #9c27b0">إمرأة</a></v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex lg3 sm6 xs12>
            <mini-statistic
                    icon="fa fa-twitter"
                    :title="countmednin"
                    sub-title="مدنين"
                    caption="إمرأة"

                    color="light-blue"
            >
            </mini-statistic>
          </v-flex>
          <!-- mini statistic  end -->
        </v-layout>
      </v-container>

      <v-container grid-list-xl fluid  style="direction: rtl">

        <v-layout row wrap >
          <v-flex lg12 sm12 xs12>
            <h3 style=" color: #0d47a1"><u>قاعدة البيانات</u> </h3>
          </v-flex>
          <v-flex lg12 sm12 xs12 >
            <v-card style="padding-left: 20px;padding-right: 20px">
            <v-layout row wrap style="direction: rtl" >
              <v-flex lg6 sm12 xs12 >

                  <v-toolbar card color="white"style=" padding-left: 5%">
                    <v-text-field
                            flat
                            placeholder="البحث ..."
                            v-model="name"
                            hide-details
                    ></v-text-field>
                    <v-btn icon @click="search1"> <v-icon>search</v-icon></v-btn>
                    <v-btn icon v-show="x2"@click="annuler"> <v-icon>exit_to_app</v-icon></v-btn>
                  </v-toolbar>

              </v-flex>
              <v-flex lg2 sm6 xs6 style="margin-top: 8px">
                <v-select
                        style="direction:ltr"
                        label="إختيار الولاية"
                        v-model="select_s"
                        :items="selections"
                        v-on:change="changedata()"
                ></v-select>
              </v-flex>
              <v-flex lg2 sm6 xs6 style="margin-top: 8px" >
                <v-select
                        style="direction:ltr"
                        label="منطقة الجمع"
                        v-model="select_zone"
                        :items="selectionz"
                        v-on:change="changezone()"
                ></v-select>
              </v-flex>
              <v-flex lg12 sm12 xs12>
                <v-layout row wrap style="direction: rtl" >
                  <v-flex lg3 sm6 xs6 style="margin-top: 8px" >
                    <v-checkbox
                            v-model="nocards"
                            label="ليس لديها بطاقة مهنية"
                            color="red"
                            value="no"
                            hide-details
                            v-on:change="itemSelectionChanged"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex lg3 sm6 xs6 style="margin-top: 8px" >

                    <v-checkbox
                            v-model="yescards"
                            label="لديها بطاقة مهنية"
                            color="primary"
                            value="yes"
                            hide-details
                            v-on:change="itemSelectionChanged"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            </v-card>
          </v-flex>
              <v-flex lg12 sm12 xs12>
                <h3    v-show="x1"style="direction: rtl" >نتائج البحث  : {{nbr}}</h3>
                <v-data-table
                        v-show="x1"
                        :headers="basic.headers"
                        :items="recherche"
                        hide-actions
                        :headers-size="20"
                        class="elevation-1"

                >
                  <template slot="items" slot-scope="props">
                    <tr>

                      <td align="center"style="font-size: 15px">{{props.item.identifier }}</td>
                      <td align="center"style="font-size: 15px">{{props.item.nom }}</td>
                      <td align="center"style="font-size: 15px">{{props.item.Gouvernorat }}</td>
                      <td align="center"style="font-size: 15px"><span v-if="(props.item.place!=null)">{{props.item.place }}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px">{{props.item.zone }}</td>
                      <td align="center"style="font-size: 15px"><span v-if="(props.item.naissance!=null)">{{props.item.naissance }}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px"> <span v-if="(props.item.cartidentite!=null)">{{props.item.cartidentite }}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px"> <span v-if="(props.item.tel!=null)">{{props.item.tel }}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px"><span v-if="(props.item.carte_pro!=null)">{{props.item.carte_pro }}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px"><span v-if="(props.item.GDA!=null)">{{props.item.GDA }}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px"><span v-if="(props.item.association!=null)">{{props.item.association }}</span><span v-else>-</span></td>
                      <td align="center"style="font-size: 15px"><span v-if="(props.item.syndic!=null)">{{props.item.syndic }}</span><span v-else>-</span></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
          <v-flex lg12 sm12 xs12>
            <h4 v-show="x3" style="margin-bottom: 20px ; color: #0d47a1"><u>قائمة النساء  :</u> {{nbr}}</h4>

            <v-data-table
                    :loading="load"

                    v-show="x3"
                    :headers="basic.headers"
                    :items="items"
                    hide-actions
                    :headers-size="20"
                    class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td align="center"style="font-size: 15px">{{props.item.identifier }}</td>
                  <td align="center"style="font-size: 15px">{{props.item.nom }}</td>
                  <td align="center"style="font-size: 15px">{{props.item.Gouvernorat }}</td>
                  <td align="center"style="font-size: 15px"><span v-if="(props.item.place!=null)">{{props.item.place }}</span><span v-else>-</span></td>
                  <td align="center"style="font-size: 15px">{{props.item.zone }}</td>

                  <td align="center"style="font-size: 15px">
                    <div style="width: 100px">
                      <span v-if='((props.item.naissance!=null)&&(props.item.naissance!=="null"))'>{{props.item.naissance }}</span><span v-else>-</span>

                    </div>

                  </td>
                  <td align="center"style="font-size: 15px"> <span v-if="((props.item.cartidentite!=null)&&(props.item.cartidentite!=='null'))">{{props.item.cartidentite }}</span><span v-else>-</span></td>
                  <td align="center"style="font-size: 15px"> <span v-if="(props.item.tel!=null)">{{props.item.tel }}</span><span v-else>-</span></td>
                  <td align="center"style="font-size: 15px"><span v-if="(props.item.carte_pro!=null)">{{props.item.carte_pro }}</span><span v-else>-</span></td>

                  <td align="center"style="font-size: 15px"> <div style="width: 200px"><span v-if="((props.item.GDA!=null)&&(props.item.GDA!=='null'))">{{props.item.GDA }}</span><span v-else>-</span>
                  </div>
                  </td>
                  <td align="center"style="font-size: 15px"><div style="width: 200px"><span v-if="((props.item.association!=null)&&(props.item.association!=='null'))">{{props.item.association }}</span><span v-else>-</span>
                  </div>
                  </td>
                  <td align="center"style="font-size: 15px"><div style="width: 200px"><span v-if="((props.item.syndic!=null)&&(props.item.syndic!=='null'))">{{props.item.syndic }}</span><span v-else>-</span>
                  </div>
                  </td>
                  <td align="center"style="font-size: 15px"><span v-if="((props.item.CNSS!=null)&&(props.item.CNSS!=='null'))">{{props.item.CNSS }}</span><span v-else>-</span></td>
                  <td align="center"style="font-size: 15px"><span v-if="((props.item.CarteMedG!=null)&&(props.item.CarteMedG!=='null'))">{{props.item.CarteMedG }}</span><span v-else>-</span></td>
                  <td align="center"style="font-size: 15px"><span v-if="((props.item.CarteMedFT!=null)&&(props.item.CarteMedFT!=='null'))">{{props.item.CarteMedFT }}</span><span v-else>-</span></td>
                  <td align="center"style="font-size: 15px"><span v-if="((props.item.SCFB!=null)&&(props.item.SCFB!=='null'))">{{props.item.SCFB }}</span><span v-else>-</span></td>
                </tr>
              </template>
            </v-data-table>

          </v-flex>
          <v-flex lg12 sm12 xs12>

            <div slot="widget-content" class="text-xs-center" v-show="x3">

              <v-pagination :length="total" v-model="page" circle :total-visible="10"></v-pagination>

            </div>
          </v-flex>
        </v-layout>

      </v-container>
    </div>
  </v-app>
</template>

<script>
  import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';

  import { getPost } from '@/api/post';
    import VWidget from '@/components/VWidget';
    import { MailMenu } from '@/api/mail';
    import Compose from './../components/email/Compose';
    export default {
        components: {
          MiniStatistic,

          Compose,
            VWidget,
        },
        props: {
            source: String
        },
      data () {
        return {
          load: false,
          e2: null,
          e3: null,
          countriess:'الكل',
          type:'Q1',
          s3:'0',
          s4:'0',   s6:'0',   s5:'0',
          g2:'0',
          g1:'0',
          g3:'0',
          countall:"+100",
          countsfax:"+100",
          countgabes:"+100",
          countmednin:"+100",
          selections: ['كل الولايات', 'صفاقس', 'مدنين', 'قابس'],
          selectionz: ['كل المناطق','s2','s4','s5', 's6', 'G1', 'G2', 'G3', 'M'],
          x1: false,
          x2: false,
          x3: true,
          nbr: 0,
          page: 1,
          s1: false,
          s2: false,
          name: '',
          select_zone: '',
          select_s: '',
          list: null,
          listLoading: true,
          tableData: [],
          recherche: [],
          nocards:'no',
          yescards  :'yes',
          countries_zone:'',

          total: 0,
          items: [],
          search: '',
          basic: {
            headers: [
              {
                text: 'الرقم',
                align: 'center',
                value: 'identifier',
              },
              {
                text: 'الإسم و اللقب',
                align: 'center',
                sortable: false,
              },
              {
                text: 'الولاية',
                align: 'center',
                sortable: false,
              },
              {
                text: 'العمادة',
                align: 'center',
                sortable: false,
              },
              {
                text: 'منطقة الجمع',
                align: 'center',
                sortable: false,
              },
              {
                text: 'تاريخ الولادة',
                align: 'center',
                sortable: false,
              },
              {
                text: 'ب.ت.و',
                align: 'center',
                sortable: false,
              },
              {
                text: 'هاتف',
                align: 'center',
                sortable: false,
              },
              {
                text: 'بطاقة مهنية',
                align: 'center',
                sortable: false,
              },

              {
                text: 'مجمع',
                align: 'center',
                sortable: false,
              },
              {
                text: 'جمعية',
                align: 'center',
                sortable: false,
              },
              {
                text: 'نقابة',
                align: 'center',
                sortable: false,
              },


              {
                text: 'الضمان الإجتماعي',
                align: 'center',
                sortable: false,
              },
             {
                text: 'بطاقة علاج مجانية',
                align: 'center',
                sortable: false,
              },
                 {
                text: 'بطاقة علاج بالتعريفة المنخفضة',
                align: 'center',
                sortable: false,
              },
      {
                text: 'منحة قارة للعائلات المعوزة',
                align: 'center',
                sortable: false,
              },

            ],
          },
        }
      },
      beforeCreate: function () {
        if (this.$session.exists()) {
          this.$router.push('/database/DB/Ar')
        }
        else { this.$router.push('/login')}
      },
        created(){
        this.load=true;

            this.start();
            this.fetchData();
          this.fetchcount();
          this.group_count()
          this.load=false;

        },
        watch: {
            page: function(newVal, oldVal) {
              if(this.select_zone===''||this.select_zone==='كل المناطق'){
                this.fetchData()
              }
              else{
                this.fetchDatazone()
              }

            }
        },
        methods: {
          start() {
            if(this.select_s===''||this.select_s==='كل الولايات')
            {
              this.select_s='tt'
            }
            this.countries_zone='countries';

            if( this.nocards==="" &&   this.yescards===""){
              this.nocards='no';
              this.yescards  ='yes';
            }

            this.$http.get('https://acg-generations.com/acg_laravel/public/paginationBDCountries1/'+this.select_s+'/'+ this.yescards+'/'+this.nocards,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
              var data = response.bodyText
              var obj = JSON.parse(data);
              this.total=obj.aa;
              this.nbr=obj.count;
            }, response => {
              // error callback
            });
          },
          changedata(){
            this.page=1;
            console.log(this.select_s)
            this.start();
            this.fetchData();
          },
          startZone() {
            this.countries_zone='zone';

            if(this.select_zone===''||this.select_zone==='كل المناطق')
            {
              this.select_zone='tt'
            }
            if( this.nocards===""&&   this.yescards===""){
              this.nocards='no';
              this.yescards  ='yes';
            }
            this.$http.get('https://acg-generations.com/acg_laravel/public/paginationBDzone1/'+this.select_zone+'/'+ this.yescards+'/'+this.nocards,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
              var data = response.bodyText
              var obj = JSON.parse(data);
              this.total=obj.aa;
              this.nbr=obj.count;
            }, response => {
              // error callback
            });
          },
          fetchDatazone() {

            if(this.select_zone===''||this.select_zone==='كل المناطق')
            {
              this.select_zone='tt'
            }
            this.cPage = this.page - 1;
            var formData = new FormData();
            formData.append('zone',this.select_zone);
            formData.append('page',this.cPage);
            this.countries_zone='zone';

            if( this.nocards===""&&   this.yescards===""){
              this.nocards='no';
              this.yescards  ='yes';
            }
            formData.append('yescards',this.yescards);
            formData.append('nocards',this.nocards);
            this.$http.post('https://acg-generations.com/acg_laravel/public/GetAllBDzone1',formData,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
              var data = response.bodyText
              var obj = JSON.parse(data);
              this.items = obj.BD;
            }, response => {
              // error callback
            });
          },
          fetchData() {
            this.countries_zone='countries';
              if(this.select_s===''||this.select_s==='كل الولايات')
              {
                this.select_s='tt'
              }
              this.cPage = this.page - 1;
              var formData = new FormData();
              formData.append('pays',this.select_s);
              formData.append('page',this.cPage);
            if( this.nocards==="" && this.yescards===""){
              this.nocards='no';
              this.yescards  ='yes';
            }
            formData.append('yescards',this.yescards);
            formData.append('nocards',this.nocards);
              this.$http.post('https://acg-generations.com/acg_laravel/public/GetAllBDCountries1',formData,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
                    var data = response.bodyText
                    var obj = JSON.parse(data);
                    this.items = obj.BD;
                }, response => {
                    // error callback
                });
            },
          itemSelectionChanged: function() {
            if(this.countries_zone==="countries"){
              this.load=true;
              this.page=1;
              this.start();
              this.fetchData();
              this.load=false;
            }
            else{
              this.load=true;
              this.page=1;
              this.startZone();
              this.fetchDatazone();
              this.load=false;
            }
          },
         /********************************************************************/
          changezone(){
            this.load=true;
            this.page=1;
            this.startZone();
            this.fetchDatazone();
            this.load=false;
          },
          search1() {
                if(this.name.length>2){
                    this.recherche=""
                    this.x1=true;
                    this.x2=true;
                    this.x3=false;
                    var formData = new FormData();
                    formData.append('nom', this.name);
                    this.$http.post('https://acg-generations.com/acg_laravel/public/getsearchBD',formData ,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
                        var data = response.bodyText
                        var obj = JSON.parse(data);
                        this.recherche = obj.count;
                        this.nbr=obj.count.length
                    }, response => {
                        // error callback
                    });
                }

            },
          pageChange (page, range) {
                console.log(page, range);
            },
          handleCurrentChange(val) {
                this.currentPage = val;
                console.log(`current page: ${val}`);
                this.fetchData()
            },
          handleClick: (e) => {
                console.log(e);
            },
          changeroute(ch){
                console.log(ch);
                if(ch==='العربية'){
                    this.$router.push('/database/Ar')

                }
                else{
                    this.$router.push('/database')
                }

            },
          openThemeSettings () {
                this.$vuetify.goTo(0);
                this.rightDrawer = (!this.rightDrawer);
            },
          fetchcount() {
            this.$http.get('https://acg-generations.com/acg_laravel/public/count_paysBD',
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
              var data = response.bodyText
              var obj = JSON.parse(data);
              this.countall=obj.count.all;
              this.countsfax=obj.count.sfax;
              this.countgabes=obj.count.gabes;
              this.countmednin=obj.count.mednin;
            }, response => {
              // error callback
            });
          },
          group_count() {
            this.$http.get('https://acg-generations.com/acg_laravel/public/group_paysBD',
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
              var data = response.bodyText
              var obj = JSON.parse(data);
              this.s3=obj.count.sfaxS2;
              this.s5=obj.count.sfaxS5;
              this.s4=obj.count.sfaxS4;
              this.s6=obj.count.sfaxS6;
              this.g2=obj.count.gabesG2;
              this.g1=obj.count.gabesG1;
              this.g3=obj.count.gabesG3;
            }, response => {
              // error callback
            });
          },
          annuler() {
            this.recherche=""
            this.x1=false;
            this.x2=false;
            this.x3=true;
            this.nbr=0

          },
        }
    }
</script>
<style>

  table.v-table thead th{
    color: black;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/BDAr.vue